import { useFormik } from 'formik';
import { Button, FormControlLabel, FormGroup, Switch } from '@mui/material';

import { ActionButtons, TitledBox } from 'components';

const getInitialValues = (options) =>
	options.reduce((values, { key, value }) => ({ ...values, [key]: value === 'true' }), {});

const ListOptions = ({ options, onFinish }) => {
	const handleFinish = (values) => {
		const payload = Object.entries(values).reduce(
			(result, [key, value]) => ({ ...result, [key]: String(value) }),
			{}
		);

		onFinish(payload);
	};

	const formik = useFormik({
		initialValues: getInitialValues(options),
		onSubmit: handleFinish,
	});

	return (
		<TitledBox title="Listados" style={{ maxWidth: 566 }}>
			<form onSubmit={formik.handleSubmit}>
				<FormGroup>
					{options.map(({ key, label }) => (
						<FormControlLabel
							key={key}
							label={label}
							control={
								<Switch
									id={key}
									name={key}
									checked={formik.values[key]}
									onChange={formik.handleChange}
								/>
							}
						/>
					))}
				</FormGroup>
				<ActionButtons style={{ marginTop: 16 }}>
					<Button color="primary" variant="contained" type="submit">
						Guardar
					</Button>
				</ActionButtons>
			</form>
		</TitledBox>
	);
};

export default ListOptions;
